<template>
  <div class="section" v-if="currentCon">
      <h1 class="convict-number" style="margin-bottom:0px;">CONVICT FOUND</h1>
       <h2 v-if="possibleCons && possibleCons.length==1000" style="margin-top:0px;">{{ (possibleIndex + 1) }} of 1000+ </h2>
      <h2 v-if="possibleCons && possibleCons.length>1 && possibleCons.length!=1000" style="margin-top:0px;">{{ (possibleIndex + 1) }} of {{ possibleCons.length }} </h2>
      <h1 :class="'convict-name '+nameTrans" @click="showConvictStory">{{ cleanName(currentCon.g) +' '+ currentCon.f }}</h1>
      <div>
         <CustomButton @click="addToQueue" :buttonTitle="'VIEW ON MEMORIAL'" :buttonIcon="'add-to-queue'" :buttonColour="'blue'" :disabled="isQueued"></CustomButton>

        <Footer :backBtn="false" :cantFindBtn="false" :detailBtn="false" :nextBtn="true" @next="nextItem"></Footer>
      </div>
     
      <div class="convict-details">
        <div style="text-align: right; color: var(--blue); margin-bottom:40px">
          <p>First Name</p>
          <p>Last Name</p>
          <p>Country</p>
          <p>Gender</p>
          <p>Trade</p>
          <p>Crime</p>
          <p>Arrival Ship</p>
          <p>Arrival Year</p>
          <p>Arrival Age</p>
          <p>Convict ID</p>
        </div>
        <div style="text-align: left;">
          <p :class="searchClass('gName')">{{cleanName(currentCon.g)}}</p>
          <p :class="searchClass('fName')">{{ currentCon.f }}</p>
          <p :class="searchClass('country')">{{ currentCon.c }}</p>
          <p :class="searchClass('gender')">{{ currentCon.s }}</p>
          <p :class="searchClass('trade')">{{ getTrade(currentCon)  || "-"}}</p>
          <p :class="searchClass('crime')">{{getCrime(currentCon) || "-"}}</p>
          <p :class="searchClass('ship')">{{ currentCon.sh || " "}}</p>
          <p :class="searchClass('year')">{{ currentCon.ya || " "}}</p>
          <p :class="searchClass('age')">{{ currentCon.a }} Years Old</p>
          <p :class="searchClass('id')">{{ currentCon.id }}</p>
        </div>
      </div>
    </div>
  
 
</template>

<script>
import flags from '@/mixins/flags.js';
import Footer from '@/components/Footer.vue';
import EntryCircleCountdown from "@/components/EntryCircleCountdown.vue";
import EntryCountdown from "@/components/EntryCountdown.vue";
import EntryCircle from "@/components/EntryCircle.vue";
import EntrySwipe from "@/components/EntrySwipe.vue";
import EntryStats from "@/components/EntryStats.vue";
import EntryDetails from "@/components/EntryDetails.vue";
import CustomButton from "@/components/CustomButton.vue";
import "/node_modules/flag-icons/css/flag-icons.min.css";
export default {
  name: "ConvictEntryView",
  mixins: [flags],
  components: {
  EntryCircleCountdown,
    EntryCountdown,
    EntryCircle,
    EntrySwipe,
    EntryStats,
    EntryDetails,
    CustomButton,
    Footer
  },
  data() {
    return {
     
      isQueued: false,
      time: 59,
      remembered: false,
      isStarted:false,
      lastPanel:0,
      isFinished:false,
      nameTrans:""
    }
  },
  mounted(){
    if(!this.possibleCons){
      this.$router.push("/search")
    }
  },
  computed: {
    mode(){
      return this.$store.getters.getMode || "search"
    },
    searchFields(){
     
      return this.$store.getters.getSearchFields
    },
    
    user() {
      return this.$store.getters.getUser
    },

    isAdmin(){
      let valid=false
      if(this.user){
        if(this.user.super){
          valid=true
        }
      }
      return valid
    },
    singleUser() {
      if (this.user) {
        return false
      }
      return true
    },
   
    testing() {
      return this.$store.getters.getTisting
    },
    panelList() {
      return this.$store.getters.getPanelList
    },
    playingPanel() {
      let playing = 0
      if (this.currentCon) {
        for (var p in this.panelList) {
          if (this.panelList[p] == this.currentCon.id) {
            playing = parseInt(p, 10) + 1
            this.isQueued = false
            this.isStarted =true
            this.lastPanel=playing
          }
        }
      }
      if(playing==0 && this.lastPanel==4 && this.isStarted){
        this.isFinished=true
      }
      return playing
    },
    queueLength() {
      return this.$store.getters.getQueueLength
    },
    startTime() {
      return this.$store.getters.getStartTime
    },
    hasNext() {},
    convictInfo() {
      return this.$store.getters.getConvict
    },
    currentCon() {
      if (this.possibleCons) {
        return this.possibleCons[this.possibleIndex]
      }
    },
    possibleCons() {
      return this.$store.getters.getPossibleConvicts
    },
    possibleIndex() {
      return this.$store.getters.getPossibleIndex
    },
    
  },
  methods: {
    searchClass(cls){
      if(this.searchFields.includes(cls)){
        return "fieldSet"
      }else{
        return "fieldRandom"
      }
    },
    goBack(){
      if(this.mode=="find"){
        this.$router.push("/find")
      }else{  
        this.$router.push("/search")
      }
   
    },
    cleanName(name){
      if(name=="undefined"){
        return ""
      }else{
        return name
      }
    },
   
    showConvictStory() {
      if(this.isAdmin ){
        this.$router.push("story")
      }
     
    },
    tradeToIcon(con) {
      let trade = this.getTrade(con)
      if (trade) {
        trade = trade.toLowerCase()
        if (trade.indexOf("smith") >= 0) {
          return "anvil"
        }
      }
      return null
    },
    getTrade(con){
      if (con.tr == "undefined") {
          return null
        } else {
          return con.tr
        }
    },
    getCrime(con) {
      if (this.convictInfo && this.convictInfo.Crime) {
        if (Array.isArray(this.convictInfo.Crime)) {
          return this.convictInfo.Crime[0]
        } else {
          return this.convictInfo.Crime
        }
      } else {
        if (con.cr == "undefined") {
          return null
        } else {
          return con.cr
        }
      }
    },
    getTrade(con) {
      if (this.convictInfo && this.convictInfo.Trade) {
        if (Array.isArray(this.convictInfo.Trade)) {
          return this.convictInfo.Trade[0]
        } else {
          return this.convictInfo.Trade
        }
      } else {
        if (con.t == "undefined") {
          return null
        } else {
          return con.t
        }
      }
    },
    doRemember(){
      let alert = {
        type: "Confirm",
        confirmAction: this.confirmRemember,
        text: ``,
        id: "REMEMBER"
      }
      console.log(alert)
      this.$store.commit("setAlert", alert)
    },
    confirmRemember() {
     
      this.remembered = true
      this.$store.commit("setAlert", false)
      if (this.convictInfo) {
        if (!this.convictInfo.dedications || this.convictInfo.dedications == "undefined") {
          this.convictInfo.dedications = 0
        }
        this.convictInfo.dedications++
        this.$store.dispatch("rememberConvict", this.convictInfo)
      }
    },
    tick() {},
    randomItem(){
      //this.currentIndex? (this.currentIndex + 1) : 0 //% this.items.length
     //this.currentIndex =3
      //console.log(this.possibleCons)
      console.log("Rnndom",this.possibleCons.length,this.currentIndex)
      let newIndex=Math.floor(Math.random()*this.possibleCons.length)
      while(newIndex==this.possibleIndex && this.possibleCons.length>1){

        newIndex=Math.floor(Math.random()*this.possibleCons.length)
      }
      this.$store.commit("setPossibleIndex",newIndex)
      //alert("Random Item "+this.possibleIndex)
    },
    nextItem() {
      if (!this.possibleCons || this.possibleCons.length === 0) return
      const next = (this.possibleIndex + 1) % this.possibleCons.length
      this.$store.commit("setPossibleIndex", next)
    },
    prevItem() {
      if (!this.possibleCons || this.possibleCons.length === 0) return
      const prev = (this.possibleIndex - 1 + this.possibleCons.length) % this.possibleCons.length
      this.$store.commit("setPossibleIndex", prev)
    },
    doSwipe(val) {
      this.$store.commit("setPossibleIndex", val)
    },
    addToQueue() {
    this.doConfirm(true)
    return
      let alert = {
        type: "Confirm",
        confirmAction: this.doConfirm,
        text: `Add ${this.cleanName(this.currentCon.g).toUpperCase()} ${this.currentCon.f.toUpperCase()} to the Queue?`,
        id:"QUEUE"
      }
      console.log(alert)
      this.$store.commit("setAlert", alert)
      // this.$router.push("/queue")
    },
    async doConfirm() {
      this.nameTrans="sendName"
      setTimeout(this.clearScreen,2000)
      console.log("Confirm", this.singleUser)
      if (this.singleUser) {
        this.$store.commit("setAlert", false)
        this.$store.dispatch("queueConvict", this.currentCon)
        this.isQueued = true
        
      } else {
        this.$store.commit("setAlert", false)
        
        this.$store.dispatch("queueConvict", this.currentCon)
        
       //this.doRemember()
       //setTimeout(this.doRemember,200)
       //setTimeout(this.showQueueList,1000)
       
      

      }
    },
    clearScreen(){
      this.$router.push("/")
    },
    showQueueList() {
      this.$router.push("/queue-list")
    }
  },
  watch: {
    convictInfo(val) {
      console.log("NEW INFO", val)
    },
    currentCon(val) {
      this.remembered = false
      this.$store.dispatch("getConvictById", val.id)
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 1em;
}
.convict-number {
  font-size: 4em;
  // margin: 0;
}
.convict-name {
  text-transform: uppercase;
  font-size: 6em;
  line-height: 0.85em;
  margin: 0.1em 0;
  color: var(--blue);
}
.convict-details {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.5em;
}





.countdown-box {
  width: 100%;
  padding: 2em 15% 1.5em;
  margin-bottom: 3em;
  background-color: var(--brick);
  position: relative;
}
.countdown-box::after {
  content: "";
  position: absolute;
  width: 1000%;
  top: 0;
  bottom: 0;
  left: -500%;
  right: -500%;
  background-color: var(--brick);
  z-index: -9999;
}
.countdown-timer {
  font-size: clamp(3.5em, 12vw, 5em);
}
mark {
  font-size: 0.75em;
  color: var(--warm-sandstone);
}

h2 {
  margin-bottom: 0.3em;
}


.fieldSet{
  color:rgb(255, 255, 255);
}
.fieldRandom{
  color:rgb(156, 155, 155);
}

.sendName{
  animation-duration: 3s;
  animation-name: rise
}
@keyframes rise {
  0% { transform: translateY(0vh); }
  100% { transform: translateY(-125vh); }
}
@media (max-width: 500px) {
  .section{
    gap:0px;
  }
    .custom-button {
      font-size: .8em; 
      width: 16em;
    }
    .convict-number {
      margin: 0px;
    font-size: 3em;
    }
    .convict-name{
      font-size: 3em;
      line-height: 1em;
      margin: 0.1em 0;
    }
  }

</style>
